export enum CONSENT_OPTION {
  ACCEPTED,
  REJECTED,
  NOT_SET,
}

export const CONSENT_LOCAL_STORAGE = 'ConsentLocalStorage';
